import React from "react";
import analytics from "web/script/analytics/analytics";
import styles from "./klarna-placement.css";

// add klarna-placement to JSX IntrinsicElements type and set window.KlarnaOnsiteService default type
declare global {
    // typescript namespace for 3rd party custom element
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            "klarna-placement": React.HTMLAttributes<HTMLDivElement>;
        }
    }
    interface Window {
        KlarnaOnsiteService: any;
    }
}

interface KlarnaPlacementProps {
    price: string;
    language: string;
    category: string;
    preload?: boolean;
}

/**
 * Represents an Onsite Message from Klarna, for more info see:
 * https://developers.klarna.com/documentation/on-site-messaging/integration/placements/
 */
export default function KlarnaPlacement({
    price,
    language,
    category,
    preload = false,
}: KlarnaPlacementProps): React.ReactElement {
    React.useEffect(() => {
        // update the Klarna Message on price change
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
        // send analytic
        analytics.event(category, "show_klarna_message", price, true);
    }, [price, category]);

    const priceInCents = price ? `${price.replace(/[^0-9]/, "")}` : "";

    return (
        <div className={styles.klarnaPlacement}>
            <klarna-placement
                data-key="credit-promotion-badge"
                data-locale={language}
                data-purchase-amount={priceInCents}
                {...(preload ? { "data-preloaded": true } : {})}
            ></klarna-placement>
        </div>
    );
}
